import type { LeaderEntry } from "@orbio/shared/protocol";

export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`missing #${id}`);
  return el;
}

export function show(id: string): void { $(id).classList.remove("hidden"); }
export function hide(id: string): void { $(id).classList.add("hidden"); }

export function setHudMass(mass: number): void {
  ($("mass") as HTMLSpanElement).textContent = String(Math.round(mass));
}

export function setMergeTimer(remainingMs: number | null): void {
  const el = $("merge-timer");
  if (remainingMs === null) {
    el.classList.add("hidden");
    return;
  }
  el.classList.remove("hidden");
  ($("merge-time") as HTMLSpanElement).textContent = (remainingMs / 1000).toFixed(1) + "s";
}

export function renderLeaderboard(entries: LeaderEntry[]): void {
  const list = $("lb-list");
  list.innerHTML = "";
  for (const e of entries) {
    const li = document.createElement("li");
    li.textContent = `${e.nick} — ${Math.round(e.m)}`;
    list.appendChild(li);
  }
}

const BUFF_LABELS: Record<string, string> = {
  pw: "POWER-UP",
  om: "SLAYER",
  sp: "SPEED",
  vc: "VACUUM",
};

export function renderBuffs(activeBuffs: { kind: 'pw' | 'om' | 'sp' | 'vc'; remainingMs: number }[]): void {
  const container = $("buffs");
  container.innerHTML = "";
  for (const b of activeBuffs) {
    const div = document.createElement("div");
    div.className = `buff buff-${b.kind}`;
    const dot = document.createElement("span");
    dot.className = "dot";
    const label = document.createTextNode(` ${BUFF_LABELS[b.kind] ?? b.kind} `);
    const timer = document.createElement("span");
    timer.className = "t";
    timer.textContent = (b.remainingMs / 1000).toFixed(1) + "s";
    div.appendChild(dot);
    div.appendChild(label);
    div.appendChild(timer);
    container.appendChild(div);
  }
}
